export default {
  deviceSettings: {
    branchId: 'Branch ID',
    companyKey: 'Company key',
    deviceId: 'Device ID',
    headingRegister: 'Register Device',
    headingUpdate: 'Change Settings Passcode',
    invalidDeviceReference: 'Your device may have been disabled by your administrator.',
    passcode: 'Passcode',
    pleaseWaitRegister: 'Please wait while we register your device',
    pleaseWaitUpdate: 'Please wait while we update your device',
    registrationFailed: 'Device Registration Failed',
    settingsPasscode: 'Settings passcode',
    newSettingsPasscode: 'New settings passcode',
    settingsPasscodeConfirm: 'Confirm settings passcode',
    successRegister: 'Success. Your device has been registered!',
    successUpdate: 'Success. Your device has been updated!',
    updateFailed: 'Device Update Failed'
  }
};